export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR'
export const PERMISSION_ERROR = 'PERMISSION_ERROR'
export const NOT_FONDED = 'NOT_FONDED'
export const NO_ERROR = 'NO_ERROR'
export const DEFAULT_ERROR = 'DEFAULT_ERROR'

export function convertErrorCodeToType(code) {
  switch (code) {
    case 200:
      return NO_ERROR
    case 204:
      return NOT_FONDED
    case 403:
      return AUTHENTICATION_ERROR
    case 606:
      return PERMISSION_ERROR
    default:
      return DEFAULT_ERROR
  }
}